export const ID = process.env.VUE_APP_GTAG_ID || 'GTM-K5WJRVNK'

export function initialize() {
  if (!ID) return

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${ID}`

  document.head.appendChild(script)
}

function event() {
  if (!ID) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(arguments)
}

export function useGtag() {
  return {
    event,
    initialize,
  }
}
